import React, { FC } from 'react';
import styled from 'styled-components';
import { SidebarMenuLink } from '../../../molecules';
import { createIcon } from '../../../organisms/EmployeeSidebar';
import SidebarShell from '../../../organisms/AppShell/SidebarShell';
import InspectionsIcon from '../../../resources/icons/hard-hat3.svg';
import Fees from '../../../resources/icons/dollar.svg';
// Hidden 2026-08 with the Documents & Reviews link -- restore together.
// import Documents from '../../../resources/icons/list.svg';
import ActivitiesIcon from '../../../resources/icons/fact_check.svg';
import Projects from '../../../resources/icons/checkmark.svg';
import Home from '../../../resources/icons/home_page.svg';
import Conditions from '../../../resources/icons/stop_sign.svg';
import Help from '../../../resources/icons/help.svg';
import { ROUTES } from './Routes/ClientRoutes';

const ClientSidebar: FC<{
  logoClassName?: string;
  isMobile?: boolean;
}> = ({ isMobile }) => {
  return (
    <ResponsiveWrapper isMobile={isMobile}>
      <SidebarShell>
        <SidebarMenuLink
          icon={() => createIcon(Home)}
          to={ROUTES.DASHBOARD}
          title="Dashboard"
        />
        <SidebarMenuLink
          icon={() => createIcon(Projects)}
          to={ROUTES.PROJECTS}
          title="My Projects/Permits"
        />
        <SidebarMenuLink
          icon={() => createIcon(InspectionsIcon)}
          to={ROUTES.INSPECTIONS}
          title="Inspections"
        />
        {/* Hidden 2026-08: Documents & Reviews. The page and its route are
            intentionally left intact -- uncomment this block to restore it. */}
        {/* <SidebarMenuLink
          icon={() => createIcon(Documents)}
          to={ROUTES.DOCUMENTS}
          title="Documents & Reviews"
        /> */}
        <SidebarMenuLink
          icon={() => createIcon(Conditions)}
          to={ROUTES.CONDITIONS}
          title="Conditions"
        />
        <SidebarMenuLink
          icon={() => createIcon(Fees)}
          to={ROUTES.INVOICES}
          title="Fees"
        />
        <SidebarMenuLink
          icon={() => createIcon(ActivitiesIcon)}
          to={ROUTES.ACTIVITIES}
          title="Activities"
        />
        <SidebarMenuLink
          icon={() => createIcon(Help)}
          to={ROUTES.HELP}
          title="Help"
        />
      </SidebarShell>
    </ResponsiveWrapper>
  );
};

export default ClientSidebar;

const ResponsiveWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  height: 100vh;

  @media only screen and (max-width: 840px) {
    display: ${({ isMobile }) => (isMobile ? 'flex' : 'none')};
  }
`;
